export const getTranslateStringForSortLabel = (value: string): string => {
  switch (value) {
    case 'count':
      return 'tlr.component_builder_dialog.sort_by.count';
    case 'stage':
      return 'tlr.component_builder_dialog.sort_by.stage';
    case 'stage-category':
      return 'tlr.component_builder_dialog.sort_by.stage_category';
    case 'stage-name':
      return 'tlr.component_builder_dialog.sort_by.stage_name';
    case 'stage-group':
      return 'tlr.component_builder_dialog.sort_by.stage_group';
    case 'rating':
      return 'tlr.component_builder_dialog.sort_by.rating';
    case 'interview-duration':
      return 'tlr.component_builder_dialog.sort_by.duration';
    case 'candidate-age':
      return 'tlr.component_builder_dialog.sort_by.age';
    default:
      return 'tlr.component_builder_dialog.sort_by.alphabetically';
  }
};
